import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

type AssumptionPanelProps = {
  title: string;
  description: string;
  children: ReactNode;
};

export function AssumptionPanel({ title, description, children }: AssumptionPanelProps) {
  return (
    <Card className="brand-frame">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">{children}</CardContent>
    </Card>
  );
}
